






import { Component, Mixins } from "vue-property-decorator";

@Component({
})
export default class InvalidOperationErrorView extends Mixins() {
}
